
import ServiceBase from './ServiceBase'

export default class Invoice extends ServiceBase {
  
}
